// import React from 'react';
// import { 
//   Typography, 
//   Paper,
//   Grid,
//   useTheme
// } from '@mui/material';
// import { 
//   Equalizer,
//   Water,
//   SolarPower,
//   ElectricBolt,
//   Cloud,
//   AvTimer,
//   CalendarToday
// } from '@mui/icons-material';
// import ParameterItem from './ParameterItem';
// import SectionHeader from './SectionHeader';
// import { useAuth } from '../../../AuthContext';

// const SystemStats = (sx) => {
//   const theme=useTheme()
//   const {pumpStats,data}=useAuth();
//   const stats = [
//     { icon: <Water />, name: 'Total Water Pumped', value: pumpStats.pump_status.total_water_discharge, unit: 'L', period: 'This Month' },
//     { icon: <SolarPower />, name: 'Total Energy Consumed ', value:pumpStats.pump_status?.total_energy_consumed, unit: 'kWh', period: 'This Month' },
//     // { icon: <ElectricBolt />, name: 'Savings', value: '₹8,450', period: 'This Month' },
//     // { icon: <Cloud />, name: 'CO2 Saved/Footprint reduced', value: '420', unit: 'kg', period: 'This Month' },
//     // { icon: <AvTimer />, name: 'Uptime', value: pumpStats.pump_status.total_running_time, unit: '%', period: '30 Days' },
//     // { icon: <CalendarToday />, name: 'Maintenance Due', value: '12', unit: 'days', period: 'Remaining' },
//   ];

//   return (
//     <Paper sx={{ 
//       borderRadius: theme.shape.borderRadius * 2,
//       overflow: 'hidden',
//       height: '100%',
//       display: 'flex',
//       flexDirection: 'column',
//       ...sx
//     }}>
//       <SectionHeader icon={<Water fontSize="small" />} title="Pump Performance" />
      
//       <Grid container spacing={1.5} sx={{ 
//         p: 2,
//         flex: 1,
//         alignContent: 'flex-start'
//       }}>
       
//         {stats.map((stat, index) => (
//           <ParameterItem 
//             key={index}
//             icon={stat.icon} 
//             name={stat.name} 
//             value={stat.value} 
//             unit={stat.unit}
            
//           />
//         ))}
//       </Grid>
//     </Paper>
//   );
// };

// export default SystemStats;




import React from 'react';
import { 
  Paper,
  Grid,
  useTheme
} from '@mui/material';
import { 
  Water,
SolarPower,
  Speed,
  Opacity,
  Power,
  DeviceThermostat,
  AvTimer
} from '@mui/icons-material';
import ParameterItem from './ParameterItem';
import SectionHeader from './SectionHeader';
import { useAuth } from '../../../AuthContext';

const SystemStats = ({ sx }) => {
  const { data ,isOnline,pumpStats} = useAuth();
 // console.log('this is total water dishcharge', pumpStats?.pump_status?.total_water_discharge)
  const theme = useTheme();

  // Format water volume to most readable unit
  const formatWaterVolume = (liters) => {
    if (!liters) return { value: '0', unit: 'L' };
    
    const absValue = Math.abs(parseFloat(liters));
    
    if (absValue >= 1000000) {
      return { value: (absValue / 1000000).toFixed(2), unit: 'ML' };
    } else if (absValue >= 1000) {
      return { value: (absValue / 1000).toFixed(2), unit: 'kL' };
    } else {
      return { value: absValue.toFixed(2), unit: 'L' };
    }
  };

  const waterVolume = formatWaterVolume(pumpStats?.pump_status?.total_water_discharge);

  const stats = [
    { icon: <Water />, name: 'Total Water Discharged', value: waterVolume.value, unit: waterVolume.unit, period: 'This Month' },
    { icon: <SolarPower />, name: 'Total Energy Consumed ', value:(Math.abs(pumpStats?.pump_status?.total_energy_consumed ?? 0)).toFixed(3), unit: 'kWh', period: 'This Month' },
    // { icon: <ElectricBolt />, name: 'Savings', value: '₹8,450', period: 'This Month' },
    // { icon: <Cloud />, name: 'CO2 Saved/Footprint reduced', value: '420', unit: 'kg', period: 'This Month' },
    // { icon: <AvTimer />, name: 'Uptime', value: pumpStats.pump_status.total_running_time, unit: '%', period: '30 Days' },
    // { icon: <CalendarToday />, name: 'Maintenance Due', value: '12', unit: 'days', period: 'Remaining' },
  ];
  return (
    <Paper sx={{ 
      borderRadius: theme.shape.borderRadius * 2,
      overflow: 'hidden',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      ...sx
    }}>
      <SectionHeader icon={<Water fontSize="small" />} title="System Statistics" />
      
      <Grid container spacing={1.5} sx={{ 
        p: 2,
        flex: 1,
        alignContent: 'flex-start'
      }}>
        {stats.map((stat, index) => (
          <ParameterItem 
            key={index}
            icon={stat.icon} 
            name={stat.name} 
            value={stat.value} 
            unit={stat.unit}
            
          />
        ))}
      </Grid>
    </Paper>
  );
};

export default React.memo(SystemStats);

